import React from "react";
import { useThemeSetting } from "./useThemeSetting";
import Theme from "./Theme";

export function ThemeFromLocalStorage({ children }: React.PropsWithChildren<{}>) {
    const { themeName } = useThemeSetting();

    return <Theme themeName={themeName}>{children}</Theme>;
}
